import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import SidebarDashboard from "../../../components/SidebarDashboard";
import WorkflowCreator from "../../../components/Modulo_Sanciones/WorkflowCreator";
import { getCasualtyMonitor } from "../../../redux/Modulo_Sanciones/Casualty_Monitor/actions";

const Monitor = (props) => {
  const filters = [
    { id: "nombre", desc: "Nombre del empleado" },
    { id: "codigo", desc: "Código del empleado" },
    { id: "zona", desc: "Zona" },
    { id: "empresa", desc: "Empresa", authorized_roles: ["administrador"] },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [show, setShow] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  const userRoles = useSelector((store) => store.auth.userRoles);

  const dispatch = useDispatch();

  const {
    casualtyMonitor,
    casualtyMonitorLength,
    loading,
    casualtyMonitorError,
  } = useSelector((store) => store.casualtyMonitor);
  const pages = Math.ceil(casualtyMonitorLength / limit);

  const columns = [
    {
      Header: "Contrato",
      accessor: "relacion_laboral__descripcion",
    },
    {
      Header: "Empresa",
      accessor: "unidad_organizativa__sociedad_financiera__nombre",
    },
    {
      Header: "Zona",
      accessor: "division_personal__descripcion",
    },
    {
      Header: "Codigo empleado",
      accessor: "codigo",
    },
    {
      Header: "Nombre empleado",
      accessor: "nombre",
    },
    {
      Header: "Función",
      accessor: "puesto__descripcion",
    },
    {
      Header: "Fecha de egreso",
      accessor: "fecha_baja",
    },
    {
      Header: "Cod. centro de costo",
      accessor: "centro_costo__codigo",
    },
    {
      Header: "Centro de costo",
      accessor: "centro_costo__descripcion",
    },
    {
      Header: "Motivo de baja",
      accessor: "descripcion_motivo_clase_medida",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          {userRoles.length > 0 &&
            (userRoles.includes("Encargado_Sanciones") ||
              userRoles.includes("administrador") ||
              userRoles.includes("Responsable_Headcount")) ? (
            <Button
              size="sm"
              className="text-dark"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">schedule_send</i>
            </Button>
          ) : null}
        </div>
      ),
    },
  ];

  // Métodos
  const _getCasualtyMonitor = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCasualtyMonitor({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
      })
    );

  useEffect(() => {
    _getCasualtyMonitor();
  }, []);

  const onEdit = (item, index) => {
    setIndex(index);
    setEditItem(item);
    setShowModal(true);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCasualtyMonitor(oOffset, limit, e.target.filter.value);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCasualtyMonitor(oOffset, limit, oSearch);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="text-uppercase d-flex flex-wrap justify-content-between align-items-center">
              <i className="material-icons mr-2">person_remove_alt_1</i>
              Monitor de bajas
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">visibility</i>
                    </Button>
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                        }
                      >
                        <Dropdown className="ml-3 mr-3">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => {
                              const tieneAcceso = !item.authorized_roles || item.authorized_roles.some(rol => userRoles.includes(rol));

                              return tieneAcceso ? (
                                <Dropdown.Item
                                  onClick={() => setTipoBusqueda(item)}
                                  key={item.id}
                                >
                                  {item.desc}
                                </Dropdown.Item>
                              ) : null;
                            })}
                          </Dropdown.Menu>
                        </Dropdown>
                      </OverlayTrigger>
                    </ButtonGroup>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            casualtyMonitorLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={casualtyMonitor} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={casualtyMonitorLength}
                  pages={pages}
                  pagFunc={_getCasualtyMonitor}
                />
              </>
            )
          )}
          {!loading &&
            casualtyMonitorLength === 0 &&
            casualtyMonitorError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!casualtyMonitorError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {casualtyMonitorError}
            </Alert>
          )}
        </Container>
      </div>
      <WorkflowCreator
        editItem={editItem}
        index={index}
        show={showModal}
        handleClose={setShowModal}
      />
    </>
  );
};

export default Monitor;
